import { createApp } from 'vue'
import __t from "../../../../helpers/translate";
import vue_helpers from "../../../../helpers/check_null";
import VueTheMask from 'vue-the-mask';
import {createBootstrap} from 'bootstrap-vue-next';
import protocol from "./protocol.vue";

window.tenderCreateProtocol = createApp({
    name : "ProtocolCreate",
    id : "ProtocolCreate",
    components : {
        protocol : protocol,
    }
})
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(VueTheMask)
    .use(v_store);

tenderCreateProtocol.mount('#protocol');